import { IAM } from '../apis.js';
const iamAPI = IAM('/keys');
export const getById = (id) => iamAPI('GET', `/${id}`);
export const getAll = (creditorId) => iamAPI('GET', creditorId ? `/?creditorId=${creditorId}` : '/');
export const create = (newKey, creditorId) => iamAPI('POST', creditorId ? `/?creditorId=${creditorId}` : '/', {
    body: newKey,
});
export const del = (id, creditorId) => iamAPI('DELETE', creditorId ? `/${id}?creditorId=${creditorId}` : `/${id}`);
//# sourceMappingURL=keys.js.map